<app-page-header
  title="Home"
  active_item="Indicadores"
  titleLink="/indicators"
></app-page-header>

<app-metabase-public-embed
  [url]="
    'https://reports.harpiatechnology.io/public/dashboard/eb4dc820-d3fc-481a-b9cc-6fc3755f5b3b'
  "
>
</app-metabase-public-embed>
